/* eslint-disable */
import { produce } from "immer";
import {
  MEMBER_LIST_FETCH_START,
  MEMBER_LIST_FETCH_SUCCESS,
  MEMBER_LIST_FETCH_FAILURE,
} from "../actions/types";

const memberList = (
  state = {
    memberListFetching: false,
    memberListData: [],
    memberListError: null,
  },
  action,
) => {
  switch (action.type) {
    case MEMBER_LIST_FETCH_START:
      return produce(state, (draft) => {
        draft.memberListFetching = true;
      });
    case MEMBER_LIST_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.memberListFetching = true;
        draft.memberListData = action.data;
        draft.memberListFetching = false;
      });
    case MEMBER_LIST_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.memberListFetching = false;
        draft.memberListError = action.error;
      });
    default:
      return state;
  }
};

export default memberList;
